import React from 'react';
import { Icon } from '@chakra-ui/react';

export const UrlIcon = () => {
	return (
		<Icon
			width="25px"
			height="6px"
			viewBox="0 0 20 5"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.97127 4.58496L2.72608 0.737654H3.89859L4.77064 4.58496H3.96454L3.07783 0.759639H3.50287L2.71875 4.58496H1.97127ZM1.67081 4.58496L1.66349 3.74955H2.47692V4.58496H1.67081ZM1.26044 4.58496L0.175861 0.605746H1.16517L2.19845 4.58496H1.26044ZM4.22103 4.58496V3.74955H5.03446L5.02713 4.58496H4.22103ZM4.54347 4.58496L5.4595 0.605746H6.38285L5.42285 4.58496H4.54347ZM8.54805 4.58496L9.30285 0.737654H10.4754L11.3474 4.58496H10.5413L9.65461 0.759639H10.0796L9.29552 4.58496H8.54805ZM8.24759 4.58496L8.24026 3.74955H9.05369V4.58496H8.24759ZM7.83721 4.58496L6.75264 0.605746H7.74194L8.77522 4.58496H7.83721ZM10.7978 4.58496V3.74955H11.6112L11.6039 4.58496H10.7978ZM11.1202 4.58496L12.0363 0.605746H12.9596L11.9996 4.58496H11.1202ZM15.1248 4.58496L15.8796 0.737654H17.0521L17.9242 4.58496H17.1181L16.2314 0.759639H16.6564L15.8723 4.58496H15.1248ZM14.8244 4.58496L14.817 3.74955H15.6305V4.58496H14.8244ZM14.414 4.58496L13.3294 0.605746H14.3187L15.352 4.58496H14.414ZM17.3746 4.58496V3.74955H18.188L18.1807 4.58496H17.3746ZM17.697 4.58496L18.613 0.605746H19.5364L18.5764 4.58496H17.697Z"
				fill="white"
			/>
		</Icon>
	);
};

export default UrlIcon;
